import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const VacanciesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const VacanciesWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 80%;
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: 1550px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const VacancyIconWrapper = styled.span`
  display: inline-block;
  width: 30px;
  text-align: center;
`;

export const VacancyIcon = styled(FontAwesomeIcon)`
  margin-right: 15px;
  font-size: 18px;
`;

export const VacanciesFilterContainer = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.darkblue};
  min-width: 30%;
  padding: 34px;
  border-radius: 24px;
  height: 100%;
  min-width: 400px;

  @media (max-width: 1550px) {
    min-width: 95%;
  }
`;

export const VacanciesFilterHeader = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  font-size: 21px;
  margin-bottom: 15px;
`;

export const VacanciesFilterLabelHeader = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  font-size: 17px;
  margin-bottom: 25px;
  font-weight: 550;
`;

export const VacanciesFilterText = styled.div`
  color: ${({ theme }) => theme.colors.darkblue};
  margin-bottom: 15px;
`;

export const VacanciesFilterInput = styled.input`
  border-radius: 24px;
  padding: 12px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.darkblue};
  font-size: 15px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.darkblue};
  }
`;

export const VacanciesOverviewContainer = styled.div`
  min-width: 80%;
  padding-top: 10px;

  @media (max-width: 1550px) {
    min-width: 100%;
  }
`;

export const VacanciesTextContainer = styled.div`
  gap: 20px;
  width: 70%;
  max-width: 1400px;
  margin-top: 40px;
  color: #17224d;
`;

export const VacanciesLocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
`;

export const VacanciesLocationInput = styled.select`
  border-radius: 24px;
  padding: 12px;
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  color: ${({ theme }) => theme.colors.darkblue};
  font-size: 15px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.darkblue};
  }
`;

export const VacanciesLocationRadius = styled.select`
  padding: 12px;
  border-radius: 24px;
  width: 30%;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  color: ${({ theme }) => theme.colors.darkblue};
  font-size: 15px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.darkblue};
  }
`;

export const VacanciesProvincesInput = styled.select`
  padding: 12px;
  border-radius: 24px;
  font-size: 15px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  color: ${({ theme }) => theme.colors.darkblue};
  margin-bottom: 15px;
`;

export const VacanciesFilterCheckboxContainer = styled.div`
  margin-left: 5px;
`;

export const VacanciesFilterCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
`;

export const VacanciesFilterCheckbox = styled.input`
  transform: scale(1.5);
  margin-right: 15px;
  appearance: none;
  background-color: #d3d3d3;
  border: 2px solid ${({ theme }) => theme.colors.darkblue};
  border-radius: 4px;
  width: 20px;
  height: 20px;

  /* When checkbox is checked, change the background color */
  &:checked {
    background-color: ${({ theme }) => theme.colors.darkblue};
    border-color: ${({ theme }) => theme.colors.darkblue};
  }

  /* Smaller checkmark */
  &:checked::after {
    content: "🗸";
    display: block;
    text-align: center;
    color: white;
    font-size: 12px; /* Smaller size for checkmark */
    line-height: 20px; /* Align vertically with the checkbox */
  }
`;

export const VacanciesFilterCheckboxLabel = styled.div`
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const VacanciesFilterRangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
`;

export const VacanciesFilterRange = styled.input`
  width: 100%;
  cursor: pointer;
  appearance: none;
  height: 8px;
  background-color: #d3d3d3;
  border-radius: 5px;
  outline: none;
  margin-bottom: 10px;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.darkblue};
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.colors.darkblue};
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  }

  /* For Firefox */
  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.darkblue};
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.colors.darkblue};
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  }

  /* For Internet Explorer */
  &::-ms-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.darkblue};
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.colors.darkblue};
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`;

export const VacanciesFilterRangeValue = styled.div`
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.darkblue};
  text-align: center;
`;

export const VacanciesOverviewOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.colors.darkblue};
  margin-bottom: 30px;
`;

export const VacanciesOverviewOption = styled.a`
  margin-right: 20px;
  text-decoration: none;
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.white : theme.colors.darkblue};
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.darkblue : theme.colors.lightgrey};

  padding: 12px 16px 12px 16px;
  border-radius: 20px;

  @media (max-width: 1550px) {
    padding-right: 10px;
  }

  @media (max-width: 1550px) {
    span {
      display: none;
    }
  }
`;

export const VacanciesCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  min-width: 80%;

  @media (max-width: 1550px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const VacanciesCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  border: 1px solid #ddd;
  border-radius: 12px;
  font-size: 14px;
  padding: 20px;
  width: 100%;
  min-height: 100%; /* Ensure consistent height */
  color: ${({ theme }) => theme.colors.darkblue};
  border: 2px solid ${({ theme }) => theme.colors.darkblue};

  @media (max-width: 1550px) {
    width: 100%;
  }
`;

export const VacanciesCardTitle = styled.h3`
  color: ${({ theme }) => theme.colors.grey};
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 400;
`;

export const VacanciesCardButton = styled.div`
  margin-top: auto; /* Pushes the button to the bottom */
  text-align: center;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue};
`;
